import { render } from "./AnnotationRow.vue?vue&type=template&id=f2705b82&scoped=true"
import script from "./AnnotationRow.vue?vue&type=script&lang=js"
export * from "./AnnotationRow.vue?vue&type=script&lang=js"

import "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=f2705b82&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2705b82"]])

export default __exports__